/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 10/23/20
 * Time: 6:14 PM
 */
import React, {Component} from 'react';
import './PublicCorporateRegistrationForm.scss';
import {Card, CardBody, CardHeader, Col, Collapse, Row} from "reactstrap";
import TxtLbl from "../../components/Input/Input/TxtLbl";
import DrpDwn from "../../components/Dropdown/Dropdown/DrpDwn";
import Lbl from "../../components/Label/Lbl";
import {Button, Form, Icon, Input} from "semantic-ui-react";
import ImageUpload from "../../components/ImageUploader/ImageUploader";
import * as actionCreator from "../../store/Action";
import {connect} from "react-redux";
import * as common from "../../const/Common/CommonFunc";
import * as EmailValidator from "email-validator";
import * as validator from "../../util/Validator";
import swal from "sweetalert";
import are_you_sure_icon from "../../assets/img/sweet/question.svg";
import axiosTags from "../../axios/axios_tag";
import apiConfig from "../../axios/axios_api_services";
import {MDBModal} from "mdbreact";
import axios from "../../axios/axios_authorization";
import VisitorImg from "../../assets/img/logos/visitor_logo.png";
import SuccessModal from "./SuccessModal/SuccessModal";

const initialState = {
  brc: '', corporateName: '',
  addressLine1: '', addressLine2: '',
  city: '', district: '', state: '', postalCode: '', country: 'Sri Lanka',
  webAddress: '', email: '', contactNo: '',
  adminEmail: '', fullName: '', adminMobile: '', password: '',
  isBlock: false, warning_msg: '', switch: false,
  expireTime: 30, otp: '',passwordType: 'password'
};

class App extends Component {
  state = Object.assign({}, initialState);

  handleChange = name => event => {
    let value = event.target.value;
    if (name === "contactNo" || name === "adminMobile" || name === "otp") {
      let isValid = validator.isOnlyNumbersValdator(value);
      if (!isValid && value !== "") {
        return;
      }
    }
    this.setState({
      [name]: value
    });
  };
  dropdownOnChange = name => (e, {value}) => {
    this.setState({
      [name]: value
    })
  };
  countDown = () => {
    let {expireTime} = this.state;
    if (expireTime > 0) {
      this.setState({expireTime: (expireTime - 1)})
    }
  };
  validationHandler = (count) => {
    let {brc, corporateName, addressLine1, addressLine2, city, district, state, postalCode, country, webAddress, email, contactNo, adminEmail, fullName, adminMobile, password} = this.state;

    brc.trim() === "" ? common.notifyMessage("Corporate BRC cannot be empty") :
      corporateName.trim() === "" ? common.notifyMessage("Corporate name cannot be empty") :
        email.trim() === "" ? common.notifyMessage("Corporate email cannot be empty") :
          !EmailValidator.validate(email) ? common.notifyMessage("Please enter valid corporate email") :
            addressLine1.trim() === "" ? common.notifyMessage("Corporate address line 1 cannot be empty") :
              city.trim() === "" ? common.notifyMessage("Please choose corporate city") :
                district === "" ? common.notifyMessage("Please choose corporate district") :
                  state === "" ? common.notifyMessage("Please choose corporate province/state") :
                    webAddress.trim() !== "" && !validator.webAddressValidator(webAddress) ? common.notifyMessage("Please enter valid web address") :
                      contactNo !== "" && !validator.contactNoValidator(contactNo) ? common.notifyMessage("Please enter valid contact number") :

                        !EmailValidator.validate(adminEmail) ? common.notifyMessage("Please enter valid admin email") :
                          fullName.trim() === "" ? common.notifyMessage("Admin full name cannot be empty") :
                            !validator.mobileNumValidator(adminMobile, "ALL", 1) ? common.notifyMessage("Please enter valid admin mobile number") :
                              !validator.passwordValidator(password) ? common.notifyMessage(validator.invalidPasswordText) :
                                // this.props.image.length === 0 ? common.notifyMessage("Please choose corporate image") :

                                  swal({
                                    title: count === 0 ? "Are you sure you want to request an OTP code?" : "Are you sure you want to submit your request?",
                                    icon: are_you_sure_icon, closeOnClickOutside: false,
                                    buttons: {
                                      cancel: 'Cancel',
                                      dangerMode: {text: "Yes", value: "action", className: "okay-btn"}
                                    },
                                  })
                                    .then((value) => {
                                      switch (value) {
                                        case "action":

                                          this.submitHandler(count);
                                          break;
                                        default:
                                      }
                                    });
  };
  submitHandler = (count) => {
    let {adminEmail, otp} = this.state;

    const obj = {
      ...this.state,
      adminMobile: this.state.adminMobile.startsWith("0") ? this.state.adminMobile : `0${this.state.adminMobile}`,
      photoPath: this.props.image.length === 0 ? "" : this.props.image[0].result,
      userName: adminEmail,
      userRoles: "CORP_ADMIN",
      otp: count === 0 ? 0 : otp
    };

    this.props.spinnerHandler(true);
    axiosTags.put(apiConfig.TEMP_CORPORATE, obj)
      .then(response => {
        if (response.data.success) {
          if (count === 0) {
            this.resendPin();
            return;
          }
          this.setState({...initialState, isBlock: true, warning_msg: response.data.message});
          this.props.imageUploaderHandler([]);
          // common.warningAlert(response.data.message, 0);
        } else {
          this.props.spinnerHandler(false);
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.submitHandler(count);
          return;
        }
        this.props.spinnerHandler(false);
      })
      .finally(fin => {
        if (count !== 0) this.props.spinnerHandler(false);
      });
  };
  viewPassword = () => {
    let i = document.getElementById("password-field");
    this.setState({passwordType: i.type === "password" ? "text":"password"});
    if (i.type === "password") {
      i.type = "text"
    } else {
      i.type = "password"
    }
  };
  resendPin = () => {
    this.setState({otp: ''});
    this.props.spinnerHandler(true);
    let adminMobile = this.state.adminMobile.startsWith("0") ? this.state.adminMobile : `0${this.state.adminMobile}`;

    axios.post(apiConfig.GUEST_USER_SEND_OTP, {mobile: adminMobile})
      .then(response => {
        if (response.data.success) {
          this.setState({switch: true, expireTime: 30})
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(error => {
        common.checkErrorResponse(error);
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      })
  };

  componentDidMount() {
    this.timer = setInterval(this.countDown, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  render() {

    let {expireTime, isBlock,passwordType} = this.state;
    return (
      <div className={"public-corp-reg-form guest-user-reg-form"}>
        {!isBlock ? <Row className={"corp-reg-form "}>
            <Col xs={12} className={"padd_grap"}>
              <h4 className={"reg-form-main-topic"}>Corporate Registration</h4>
              <div className={"corp-reg-img"}>
                <img src={VisitorImg} alt={"."}/>
              </div>
            </Col>
            <Col xs="12" lg={"6"} md={"6"} className={"padd_grap"}>
              <Card className={this.state.completeCorporate ? "border-danger" : null}>
                <CardHeader>
                  Corporate Details
                </CardHeader>
                <Collapse isOpen={true} id="collapseExample">
                  <CardBody>

                    {/*corporate details*/}
                    <Form>
                      <Form.Group widths='equal'>
                        <TxtLbl
                          required
                          tagText={"Corporate BRC"}
                          placeholder={"BRC"}
                          value={this.state.brc}
                          onChange={this.handleChange('brc')}
                        />
                      </Form.Group>

                      <Form.Group widths='equal'>
                        <TxtLbl
                          required
                          tagText={"Corporate Name"}
                          placeholder={"Corporate name"}
                          value={this.state.corporateName}
                          onChange={this.handleChange('corporateName')}
                        />
                      </Form.Group>

                      <Form.Group widths='equal'>
                        <TxtLbl
                          required
                          tagText={"Corporate Email"}
                          placeholder={"Email"}
                          value={this.state.email}
                          onChange={this.handleChange('email')}
                        />
                      </Form.Group>
                    </Form>
                    <br/>
                    {/*address*/}
                    <Form className={"_"}>
                      <Form.Group widths='equal'>
                        <TxtLbl
                          required
                          tagText={"Address Line 1"}
                          placeholder={"Address Line 1"}
                          value={this.state.addressLine1}
                          onChange={this.handleChange('addressLine1')}
                        />

                        <TxtLbl
                          tagText={"Address Line 2"}
                          placeholder={"Address Line 2"}
                          value={this.state.addressLine2}
                          onChange={this.handleChange('addressLine2')}
                        />
                      </Form.Group>

                      <Form.Group widths='equal'>
                        <TxtLbl
                          required
                          tagText={"City/Town"}
                          placeholder={"City/Town"}
                          value={this.state.city}
                          onChange={this.handleChange('city')}
                        />
                      </Form.Group>

                      <Form.Group widths='equal'>
                        <DrpDwn
                          required
                          tagText={"District"}
                          placeholder={"Select district"}
                          options={this.props.districs_list}
                          onChange={this.dropdownOnChange('district')}
                          value={this.state.district}
                        />
                        <DrpDwn
                          required
                          tagText={"Province/State"}
                          placeholder={"Province/State"}
                          options={this.props.provinces_list}
                          onChange={this.dropdownOnChange('state')}
                          value={this.state.state}
                        />
                      </Form.Group>

                      <Form.Group widths='equal'>
                      </Form.Group>

                      <Form.Group widths='equal'>
                        <TxtLbl
                          tagText={"Zip Code"}
                          placeholder={"Zip code"}
                          value={this.state.postalCode}
                          onChange={this.handleChange('postalCode')}
                        />
                      </Form.Group>
                    </Form>

                    {/*corporate web/email/tel*/}
                    <Form className={"row_gap"}>
                      <Form.Group widths='equal'>
                        <TxtLbl
                          tagText={"Web Address"}
                          placeholder={"Web"}
                          value={this.state.webAddress}
                          onChange={this.handleChange('webAddress')}
                        />
                        <TxtLbl
                          tagText={"Telephone"}
                          placeholder={"Telephone"}
                          value={this.state.contactNo}
                          onChange={this.handleChange('contactNo')}
                        />
                      </Form.Group>
                    </Form>

                  </CardBody>
                </Collapse>
              </Card>
            </Col>

            {/*corporate admin details*/}

            <Col xs="12" lg={"6"} md={"6"} className={"padd_grap"}>
              <Card className={this.state.completeBill ? "border-danger" : null}>
                <CardHeader>
                  Corporate Administrator Details
                </CardHeader>
                <Collapse isOpen={true} id="collapseExample">
                  <CardBody>
                    <Form>
                      <Form.Group widths='equal'>
                        <TxtLbl
                          required
                          tagText={"Email"}
                          placeholder={"Email"}
                          value={this.state.adminEmail}
                          onChange={this.handleChange('adminEmail')}
                        />
                      </Form.Group>
                    </Form>
                    <Form>
                      <Form.Group widths='equal'>
                        <TxtLbl
                          required
                          tagText={"Full Name"}
                          placeholder={"Full Name"}
                          value={this.state.fullName}
                          onChange={this.handleChange('fullName')}
                        />
                      </Form.Group>
                    </Form>
                    <Form>
                      <Form.Group widths='equal'>
                        <TxtLbl
                          required
                          tagText={"Mobile"}
                          placeholder={"Mobile"}
                          value={this.state.adminMobile}
                          onChange={this.handleChange('adminMobile')}
                        />
                      </Form.Group>
                    </Form>
                    <br/>
                    <Form>
                      <Form.Group widths='equal'>
                        <TxtLbl
                          required
                          disable
                          tagText={"Username"}
                          placeholder={"Username"}
                          value={this.state.adminEmail}
                        />
                      </Form.Group>

                      <Col className={"none-padding"} lg={12}>
                        <Lbl required>Password</Lbl>
                        <Input id={"password-field"} type={"password"}
                               onChange={this.handleChange('password')}
                               value={this.state.password}
                               style={{width: '100%'}}
                               icon={<Icon onClick={() => this.viewPassword(false)}
                                           onClick={() => this.viewPassword(true)} name={passwordType === "password"?'eye':'eye slash'} circular link/>}
                               placeholder='Password'/>
                      </Col>
                    </Form>

                  </CardBody>
                </Collapse>
              </Card>

              {/*contract details*/}

              <CardBody>
                <Row>
                  <Col lg={12} className={"text-align-path col_gap"}>
                    <Lbl>Choose Corporate Logo</Lbl>
                    <ImageUpload/>
                  </Col>
                </Row>
              </CardBody>

            </Col>

            <Col lg={"12"} className={"text-align-path"} style={{marginBottom: '5px'}}>
              <Button className="px-5" onClick={() => this.validationHandler(0)}>Continue</Button>
            </Col>
          </Row>
          :
          <SuccessModal />
        }
        {
          this.state.switch &&
          <MDBModal isOpen={this.state.switch} toggle={() => {
          }} size="md" className={"user-verification-modal guest-reg-form"}>
            <h4 className={"reg-form-main-topic"}>OTP Verification</h4>
            <Row>
              <Col xs={12}>
                <p
                  className="warning-muted">{`We've sent a verification code to your ${this.state.adminMobile} mobile via SMS. Please provide it below`}</p>
              </Col>
              <Col xs={12}>
                <div className={"otp-form"}>
                  <Form>
                    <Form.Group widths='equal'>
                      <TxtLbl
                        required
                        tagText={"Verification Code"}
                        placeholder={"Verification Code"}
                        value={this.state.otp}
                        onChange={this.handleChange('otp')}
                      />
                    </Form.Group>
                  </Form>
                  {expireTime === 0 &&
                  <p className={"expire-text"}>{"Didn't receive the code? "} <label className={'resend-text'}
                                                                                    onClick={this.resendPin}>Resend</label>
                  </p>}
                  {expireTime !== 0 && <p className={"expire-text"}>Didn't receive the code?
                    00:<label>{expireTime < 10 ? `0${expireTime}` : expireTime}</label></p>}
                </div>
                <p className={"align-right"} style={{color: 'gray', textDecoration: 'underline', cursor: "pointer"}}
                   onClick={() => this.setState({switch: false})}>Change details</p>
              </Col>
              <Col xs={12}>
                <Button className="px-5" onClick={() => this.validationHandler(1)}>Verify</Button>
              </Col>
            </Row>

          </MDBModal>
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  image: state.imageReducer.image,
  usr_obj: state.userReducer.user,
  provinces_list: state.addCorporateReducer.provinces,
  districs_list: state.addCorporateReducer.districs,

});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    //user data handler:
    userHandler: (data) => dispatch(actionCreator.userHandler(data)),
    // reception meeting shedule handler
    imageUploaderHandler: (image) => dispatch(actionCreator.imageUploaderHandler(image))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
